import React, { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { getWorkStartDateRequest, getDepartmentsRequest } from './api';
import AnniversaryCard from './AnniversaryCard';

import {
  setHeaderConfigsAction,
  setHeaderTitleAction
} from '../../../reactRedux/Actions/headerAction';
import { useDispatch } from 'react-redux';
import styles from './styles.module.scss';
import Loader from '../../common/Loader';
import { getMyProfileRequest } from '../../../helpers/api';
import classNames from 'classnames';
import Button from '@mui/material/Button';
import { useTranslation } from '../../../i18n/LanguageProvider';

const WorkStartDateAnniversary = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [departmentId, setDepartmentId] = useState();

  const { isLoading, data } = useQuery(
    ['work_start_date', departmentId],
    () => getWorkStartDateRequest(departmentId),
    {
      onError(err) {
        toast.error(err.response?.data?.detail);
      }
    }
  );

  const { isLoading: organizationIdIsLoading, data: organizationIdData } =
    useQuery(['myProfile'], getMyProfileRequest, {
      select: React.useCallback((data) => data?.data?.organization?.id, [])
    });

  const { data: departmentsIdData } = useQuery(
    ['departmentsList'],
    () => getDepartmentsRequest(organizationIdData),
    {
      enabled: !organizationIdIsLoading
    }
  );

  const setHeader = (title) => dispatch(setHeaderTitleAction(title));
  const setHeaderConfigs = (configs) =>
    dispatch(setHeaderConfigsAction(configs));

  useEffect(() => {
    setHeader(t('occasions.anniversariesHeader'));
    setHeaderConfigs({ credits: false, exit: false, back: true });
  }, []);
  return (
    <div>
      <div className={styles.section}>
        <div className={styles.sectionBody}>
          <h3>{t('occasions.anniversariesThisMonth')}</h3>
          {!!departmentsIdData?.length && (
            <div className={styles.selectButton}>
              <Button variant="outlined" size="small">
                <select
                  value={departmentId}
                  onChange={(e) =>
                    isNaN(e.target.value)
                      ? setDepartmentId(null)
                      : setDepartmentId(e.target.value)
                  }
                >
                  <option>{t('common.allDepartments')}</option>
                  {departmentsIdData.map((value) => (
                    <option key={value.id} value={value.id}>
                      {value.name}
                    </option>
                  ))}
                </select>
              </Button>
            </div>
          )}
        </div>
      </div>
      {isLoading ? (
        <Loader />
      ) : !(
          data?.today?.length +
          data?.upcoming?.length +
          data?.past?.length
        ) ? (
        <div className={styles.empty}>{t('occasions.noAnniversaries')}</div>
      ) : (
        <>
          {!!data.today?.length && (
            <div
              className={classNames(styles.section, styles.anniversarySection)}
            >
              <div className={styles.sectionBody}>
                {t('occasions.todayAnniversaries')}
              </div>
              <div className={styles.sectionBody}>
                {data.today.map((user) => (
                  <AnniversaryCard
                    key={user.id}
                    user={user}
                    extraClass={styles.anniversaryCard}
                    isToday={true}
                  ></AnniversaryCard>
                ))}
              </div>
            </div>
          )}
          {!!(data.tomorrow?.length + data.upcoming?.length) && (
            <div
              className={classNames(styles.section, styles.anniversarySection)}
            >
              <div className={styles.sectionBody}>
                {t('occasions.upcomingAnniversaries')}
              </div>
              <div className={styles.sectionBody}>
                {data.tomorrow.map((user) => (
                  <AnniversaryCard
                    key={user.id}
                    user={user}
                    extraClass={styles.anniversaryCard}
                    isTomorrow={true}
                  ></AnniversaryCard>
                ))}
                {data.upcoming.map((user) => (
                  <AnniversaryCard
                    key={user.id}
                    user={user}
                    extraClass={styles.anniversaryCard}
                  ></AnniversaryCard>
                ))}
              </div>
            </div>
          )}

          {!!data.past?.length && (
            <div
              className={classNames(styles.section, styles.anniversarySection)}
            >
              <div className={styles.sectionBody}>
                {t('occasions.pastAnniversaries')}{' '}
              </div>
              <div className={styles.sectionBody}>
                {data.past.map((user) => (
                  <AnniversaryCard
                    key={user.id}
                    user={user}
                    extraClass={styles.anniversaryCard}
                  ></AnniversaryCard>
                ))}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default WorkStartDateAnniversary;
